export enum OcbSpPlatforms {
    Online = 0,
    OnPremise = 1,
}

export enum OcbPlatformType {
    FTP = 'FTP',
    HTTP = 'HTTP',
    SFTP = 'SFTP',
    SharePoint = 'SharePoint',
    AzureStorage = 'AzureStorage',
}

export enum OcbSftpVersion {
    SFTP0 = 1,
    SFTP1 = 2,
    SFTP2 = 4,
    SFTP3 = 8,
    SFTP4 = 16,
    SFTP5 = 32,
    SFTP6 = 64,
}
